/* Туслахууд — дизайны shared.jsx-ээс (carTotal нь server subtotal болсон) */
import type { QueueCar } from './types';

export const tug = (n: number) => n.toLocaleString('en-US') + '₮';

/* Нийт дүн — server-ээс ирсэн line snapshot-уудын нийлбэр */
export const carTotal = (car: QueueCar) => car.subtotal;

export const elapsedText = (enteredAt: number, now: number) => {
  const m = Math.max(0, Math.round((now - enteredAt) / 60000));
  return m < 60 ? `${m} мин` : `${Math.floor(m / 60)} ц ${m % 60} мин`;
};

export const enteredTimeText = (enteredAt: number) => {
  const d = new Date(enteredAt);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const matchesQuery = (car: QueueCar, q: string) => {
  const s = q.trim().toLowerCase();
  if (!s) return true;
  const hay = (car.plate + ' ' + car.type + ' ' + car.washerNames + ' ' + car.services.join(' ')).toLowerCase();
  return s.split(/\s+/).every((w) => hay.includes(w));
};

/* "1234уба" → "1234 УБА" */
export const formatPlate = (raw: string) => {
  const s = raw.toUpperCase().replace(/\s+/g, '').slice(0, 7);
  const m = s.match(/^(\d{0,4})(.*)$/)!;
  return m[1] + (m[2] ? ' ' + m[2] : '');
};
